<template>
  <div v-if="project.owner">
    <div v-if="project.status === 'created'">
      <checkbox v-model="domoreConsent">
        <b slot="label">{{ $t('project.verification.acceptRules') }}</b>
      </checkbox>
      <checkbox v-model="mangopayConsent">
        <b slot="label">{{ $t('project.verification.acceptMangopayRules') }}</b>
      </checkbox>
    </div>

    <button v-if="project.status === 'created'"
      @click='verifyProject'
      type="button"
      :class="'btn btn-default btn-lg button-wide-' + crowd_or_rais">
      <span v-show="!processing">{{ $t("project.verification.verifyBtn") }}</span>
      <clip-loader :loading="processing" :color="'#fff'" size="17px"></clip-loader>
    </button>
    <button v-if="project.status === 'pending'" type="button" class="btn btn-default btn-lg mt-20 btn-wide crowdfunding disabled">
      <span v-show="!processing">{{ $t("project.verification.verifying") }}</span>
      <clip-loader :loading="processing" :color="'#fff'" size="17px"></clip-loader>
    </button>
    <button v-if="project.status === 'approved'" @click="publishProject" type="button" :class="'btn btn-default btn-lg mt-20 button-wide-' + crowd_or_rais">
      <span v-show="!processing">{{ $t("project.verification.publish") }}</span>
      <clip-loader :loading="processing" :color="'#fff'" size="17px"></clip-loader>
    </button>
    <alert :success="verificationInfo" :error="verificationError" class="mt-20 mb-0"></alert>

    <!-- User KYC documents -->
    <light-kyc @fetch:user="setUser" ref="lightKyc"/>
    <regular-kyc v-if="user.mangopay_id || project.submitted" :documentId="user.kyc_document_id" @submitted="setKycIds"/>
  </div>
</template>

<script>
// API
import projectsApi from '@/api/v1/projects';
// Components
import Alert from '@/components/Alert';
import LightKyc from '@/components/Profile/LightKYC';
import RegularKyc from '@/components/Profile/Kyc';
import ClipLoader from 'vue-spinner/src/ClipLoader';
import Checkbox from '@/components/Utils/Inputs/Checkbox';

export default {
  components: { Alert, LightKyc, RegularKyc, ClipLoader, Checkbox },
  props: ['project'],
  data() {
    return {
      verificationInfo: '',
      verificationError: '',
      processing: false,
      mangopayConsent: false,
      domoreConsent: false,
      user: {},
    };
  },
  computed: {
    crowd_or_rais() {
      return this.project.crowdfunding ? 'crowd' : 'rais';
    },
  },
  methods: {
    verifyProject() {
      if (!this.checkConsents()) {
        this.verificationError = this.$t('project.verification.acceptRulesError');
        return;
      }
      this.processing = true;

      projectsApi.verifyProject(this.project.id).then((response) => {
        this.processing = false;
        this.project.status = response.data.status;
        this.project.submitted = true;
        this.verificationInfo = this.$t('project.verification.verificationAlert');
      }).catch((response) => {
        this.processing = false;
        if (response.response.data.errors.kyc) {
          this.$refs.lightKyc.open();
        } else {
          this.verificationError = response.response.data.errors[0];
        }
      });
    },
    publishProject() {
      projectsApi.publishProject(this.project.id).then((response) => {
        this.project.status = response.data.status;
        this.project.published = true;
        this.verificationInfo = this.$t('project.verification.publishAlert');
      }).catch((response) => {
        this.verificationError = response.response.data.user[0];
      });
    },
    setUser(user) {
      this.user = user;
    },
    setKycIds(document) {
      this.user.kyc_document_id = document.Id;
      this.user.mangopay_id = document.UserId;
    },
    checkConsents() {
      return this.mangopayConsent && this.domoreConsent;
    },
  },
};
</script>



// WEBPACK FOOTER //
// Verification.vue?38cd4489